import { isAirportClient } from '~/config/airports.config';

/**
 * Lien discret « Toi aussi, lance ces jeux » sur le téléphone des joueurs, en bas
 * de l'écran entre deux jeux (InterGameScreen). Acquisition : les inscrits
 * « vu dans un bar » passent payants plus souvent que ceux de la pub.
 * Décision Victorien 13/10/2026 : partout chez les bars (animateurs compris),
 * formulation générale, jamais en aéroport.
 *
 * Interrupteur : passer à `false` puis mettre en ligne la console.
 */
export const PLAYER_LINK_ENABLED = true;

const SITE_URL = 'https://unboared.com/';

/**
 * Clients sous contrat ou espaces de démo (pas d'abonnement Stripe) : jamais de lien,
 * même en mode animé (Ninkasi, Zénith, salles, espaces de démo aéroport…).
 * Liste relevée le 13/10/2026 (clients Firestore sans abonnement Stripe) ; à compléter
 * à chaque nouveau client sous contrat. Le téléphone ne peut pas lire la fiche client.
 */
const EXCLUDED_PREFIXES = ['airport-', 'ninkasi-', 'zenith-', 'demo'];
const EXCLUDED_CLIENT_IDS = new Set([
    'accor-arena',
    'agence-bisons',
    'avolta',
    'barcadia',
    'bde-telecom-paris',
    'buffalo-beauvais-allone',
    'casino-barriere-la-baule',
    'digital-bike',
    'followpark',
    'fragments-studio',
    'groupe-ADP',
    'le-phare-grand-chambery',
    'les-coulisses-pub',
    'novicks-stadium',
    'paris-basketball',
    'patinoire-grand-chambery',
    'raton-buveur-paris13',
    'yokai-cafe-lyon',
    'test',
    'victo',
    'mUSMu96V4zWFjzNblHdq', // espace démo temporaire Marseille (Emilie)
    'CG3AWxGWp3NnBhAkim4b',
    'KhzwgMypGvypTzJ3i58X',
    'cXXQDKemy1re0lXfjIbt',
    'oWzeAtvcfvK8xtYawMQ5',
]);

export function isExcludedClient(clientID: string): boolean {
    return (
        isAirportClient(clientID) ||
        EXCLUDED_CLIENT_IDS.has(clientID) ||
        EXCLUDED_PREFIXES.some((prefix) => clientID.startsWith(prefix))
    );
}

/**
 * Seulement en mode animé (bars/animateurs). Le téléphone démarre en `auto` et passe
 * en `anim` quand l'écran répond à sa connexion : le lien apparaît à ce moment-là.
 */
export function shouldShowPlayerLink(
    mode: string | undefined,
    clientID: string | undefined,
    freePlay: boolean
): boolean {
    return PLAYER_LINK_ENABLED && mode === 'anim' && !!clientID && !isExcludedClient(clientID) && !freePlay;
}

/**
 * Pas de GA sur /gamepad (firebase.config) : la mesure passe par les UTM, que le site
 * transmet à l'inscription puis aux métadonnées Stripe. `utm_content` = le lieu d'où vient le visiteur.
 */
export function playerLinkUrl(clientID: string): string {
    const params = new URLSearchParams({
        utm_source: 'gamepad',
        utm_medium: 'referral',
        utm_campaign: 'player_link',
        utm_content: clientID,
    });
    return `${SITE_URL}?${params.toString()}`;
}
